// extracted by mini-css-extract-plugin
export default {"container":"t3GS__O sOoULa1 leavesden4","link":"XDylSbP sOoULa1 leavesden4"};